"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REFERRAL_ELIGIBILITY = exports.PATIENT_PROFILE_LIST = exports.PATIENT_PROFILE = exports.GUEST_CHECKOUT_REGISTER = exports.FAMILY_MEMBER = exports.EDIT_PATIENT_PROFILE = exports.DELETE_PATIENT_PROFILE = exports.COMPLETE_PROFILE = exports.CHECK_PATIENT_IN_HIS = exports.CHECK_PATIENT_IN_AKHILHIS = exports.ADD_FAMILY_MEMBER = void 0;
const COMPLETE_PROFILE = exports.COMPLETE_PROFILE = 'completeProfileApi';
const GUEST_CHECKOUT_REGISTER = exports.GUEST_CHECKOUT_REGISTER = 'completeProfileApi';
const PATIENT_PROFILE = exports.PATIENT_PROFILE = 'patientProfile';
const PATIENT_PROFILE_LIST = exports.PATIENT_PROFILE_LIST = 'patientProfileList';
const EDIT_PATIENT_PROFILE = exports.EDIT_PATIENT_PROFILE = 'editProfile';
const DELETE_PATIENT_PROFILE = exports.DELETE_PATIENT_PROFILE = 'deleteProfile';
const CHECK_PATIENT_IN_HIS = exports.CHECK_PATIENT_IN_HIS = 'checkPatientInHis';
const CHECK_PATIENT_IN_AKHILHIS = exports.CHECK_PATIENT_IN_AKHILHIS = 'checkPatientInAkhilHis';
const FAMILY_MEMBER = exports.FAMILY_MEMBER = 'familyMember';
const ADD_FAMILY_MEMBER = exports.ADD_FAMILY_MEMBER = 'addFamilyMember';
const REFERRAL_ELIGIBILITY = exports.REFERRAL_ELIGIBILITY = 'referralEligibility';